import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds, teamIds } from 'src/constants/personalizationIds'
import { promoCodes } from 'src/constants'

export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    offerBanner={{
      title: ['Special offer for Astros fans:', 'Enjoy 7 days FREE + $20 off your first month'],
    }}
    offerCode={promoCodes.houston_astros}
    video={videos.houston_astros.videoUrl}
    staticAnnotation={videos.houston_astros.staticAnnotation}
    pageTitle="Watch Houston Astros baseball"
    title={
      <>
        Watch Houston Astros<sup>®</sup> baseball
      </>
    }
    subtitle="Get live games, local team coverage & more. Regional restrictions apply."
    networkSet="baseball"
    customNetworks={['spacecity']}
    logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-astros.png?w=450&ch=width&auto=format,compress"
    logoHeight="100px"
    league="MLB"
    sportId={sportIds.Baseball}
    leagueId={leagueIds.MLB}
    teamId={teamIds['Houston Astros']}
  />
)
